// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h328A22ukCPkXAIXdEhd .ant-modal-content {

    border-radius: 10px;

    padding: 2rem
}

.ItlI_4lTXK1vDGjfLY7o {

    margin-bottom: 1.5rem;

    text-align: center;

    font-family: Noto Sans;

    font-size: 18px;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.u2j0EpiFNGwQ41dyKERZ {

    display: flex;

    align-items: center;

    justify-content: space-between;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-family: Noto Sans;

    font-size: 14px;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.b3uasActyMUJtYzpaBtn {

    margin-top: 0.5rem;

    margin-bottom: 0.5rem;

    border-top-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(228 228 228 / var(--tw-border-opacity, 1))
}

.aJcyX9I_W4nWMxmxz3Fc {

    margin-bottom: 1.5rem;

    display: flex;

    align-items: center;

    justify-content: space-between;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-family: Noto Sans;

    font-size: 14px;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.hYpEHiZuXgFVU0hY3DXI {

    margin: auto;

    display: flex;

    height: 42px;

    width: 100%;

    justify-content: center;

    border-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.hYpEHiZuXgFVU0hY3DXI:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/TransactionDetailsModal/TransactionDetailsModal.module.css"],"names":[],"mappings":"AACE;;IAAA,mBAAyB;;IAAzB;AAAyB;;AAIzB;;IAAA,qBAAsE;;IAAtE,kBAAsE;;IAAtE,sBAAsE;;IAAtE,eAAsE;;IAAtE,gBAAsE;;IAAtE,oBAAsE;;IAAtE;AAAsE;;AAItE;;IAAA,aAAkF;;IAAlF,mBAAkF;;IAAlF,8BAAkF;;IAAlF,mBAAkF;;IAAlF,sBAAkF;;IAAlF,sBAAkF;;IAAlF,eAAkF;;IAAlF,oBAAkF;;IAAlF;AAAkF;;AAIlF;;IAAA,kBAAoC;;IAApC,qBAAoC;;IAApC,qBAAoC;;IAApC,sBAAoC;;IAApC;AAAoC;;AAIpC;;IAAA,qBAAiG;;IAAjG,aAAiG;;IAAjG,mBAAiG;;IAAjG,8BAAiG;;IAAjG,mBAAiG;;IAAjG,sBAAiG;;IAAjG,sBAAiG;;IAAjG,eAAiG;;IAAjG,gBAAiG;;IAAjG,oBAAiG;;IAAjG;AAAiG;;AAIjG;;IAAA,YAAkB;;IAAlB,aAAkB;;IAClB,YAAyE;;IAAzE,WAAyE;;IAAzE,uBAAyE;;IAAzE,kBAAyE;;IAAzE,kBAAyE;;IAAzE,0DAAyE;;IAAzE,oBAAyE;;IAAzE;AADkB;;AAKlB;;IAAA,6BAA8B;;IAA9B,qEAA8B;;IAA9B,+BAA8B;;IAA9B;AAA8B","sourcesContent":[".modal :global(.ant-modal-content) {\n  @apply rounded-[10px] p-8;\n}\n\n.title {\n  @apply text-center font-inter font-bold text-[18px] text-gray-600 mb-6;\n}\n\n.row {\n  @apply flex items-center justify-between font-inter text-[14px] text-gray-500 py-2;\n}\n\n.divider {\n  @apply border-t border-gray-200 my-2;\n}\n\n.totalRow {\n  @apply flex items-center justify-between font-inter font-bold text-[14px] text-gray-600 py-2 mb-6;\n}\n\n.closeButton {\n  @apply flex m-auto;\n  @apply bg-primary text-white w-full h-[42px] justify-center rounded-[5px];\n}\n\n.closeButton:hover {\n  @apply !bg-primary !text-white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `h328A22ukCPkXAIXdEhd`,
	"title": `ItlI_4lTXK1vDGjfLY7o`,
	"row": `u2j0EpiFNGwQ41dyKERZ`,
	"divider": `b3uasActyMUJtYzpaBtn`,
	"totalRow": `aJcyX9I_W4nWMxmxz3Fc`,
	"closeButton": `hYpEHiZuXgFVU0hY3DXI`
};
export default ___CSS_LOADER_EXPORT___;
